import { render, staticRenderFns } from "./viewMainFee.vue?vue&type=template&id=05c14e12&scoped=true"
import script from "./viewMainFee.vue?vue&type=script&lang=js"
export * from "./viewMainFee.vue?vue&type=script&lang=js"
import style0 from "./viewMainFee.vue?vue&type=style&index=0&id=05c14e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c14e12",
  null
  
)

export default component.exports